import { constants } from '@bingads-webui-cc-react/common-styles';

const { commonFormControl: { maxWidth } } = constants;

export const LineByLineFormGroupStyles = () => ({
  formControl: {
    '& .form-control-container': {
      maxWidth,
    },
  },
});
